import { useState, useEffect } from 'react';

export function useFilePreview(
  initialFile: File | null = null,
  initialPreview: string | null = null
) {
  const [file, setFile] = useState<File | null>(initialFile);
  const [preview, setPreview] = useState<string | null>(initialPreview);

  useEffect(() => {
    if (!file) return;
    const reader = new FileReader();
    reader.onloadend = () => setPreview(reader.result as string);
    reader.readAsDataURL(file);
  }, [file]);

  return { file, preview, setFile, setPreview };
}
